import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import auth from "./slice/auth";
import profile from "./slice/profile";
import booking from "./slice/booking";
const rootReducer = combineReducers({
  auth,
  profile,
  booking,
});
const store = configureStore({
  reducer: rootReducer,
});
export default store;
